/* eslint-disable react/jsx-props-no-spreading */
import { styled } from 'styled-components';
import { SortDirections } from './Helper';

export const HelpIcon = (props) => (
  <svg
    {...props}
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM7 12C7.55228 12 8 11.5523 8 11C8 10.4477 7.55228 10 7 10C6.44772 10 6 10.4477 6 11C6 11.5523 6.44772 12 7 12ZM7.0061 8.99998C7.43372 8.99658 7.77764 8.6444 7.77427 8.21335C7.77412 8.19422 7.84774 8.152 7.94325 8.09723C7.99252 8.06897 8.04762 8.03738 8.10143 8.00388C8.12549 7.9889 8.14668 7.97575 8.16575 7.9639C8.21116 7.93571 8.24461 7.91494 8.27656 7.89458C9.09221 7.37484 9.5 6.72162 9.5 5.52003C9.5 4.12357 8.38249 3 7 3C5.61929 3 4.5 4.12826 4.5 5.52003C4.5 5.95109 4.84666 6.30053 5.2743 6.30053C5.70193 6.30053 6.0486 5.95109 6.0486 5.52003C6.0486 4.99038 6.47455 4.561 7 4.561C7.52811 4.561 7.9514 4.98659 7.9514 5.52003C7.95141 6.14863 7.84111 6.32531 7.44909 6.57511C7.41265 6.59833 7.37355 6.6226 7.28772 6.67574L7.28496 6.67746C6.56379 7.1264 6.21882 7.34115 6.22573 8.22564C6.22909 8.65669 6.57848 9.00337 7.0061 8.99998Z'
      fill='#D8D8D8'
    />
  </svg>
);

export const PeopleIcon = ({ className }) => (
  <svg
    className={className}
    width='22'
    height='22'
    viewBox='0 0 22 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.0003 6.33333C11.0003 8.17428 9.50796 9.66667 7.66701 9.66667C5.82606 9.66667 4.33368 8.17428 4.33368 6.33333C4.33368 4.49238 5.82606 3 7.66701 3C9.50796 3 11.0003 4.49238 11.0003 6.33333ZM17.6663 7.16684C17.6663 8.54755 16.547 9.66684 15.1663 9.66684C13.7856 9.66684 12.6663 8.54755 12.6663 7.16684C12.6663 5.78613 13.7856 4.66684 15.1663 4.66684C16.547 4.66684 17.6663 5.78613 17.6663 7.16684ZM1 17.394C1 14.0469 3.71343 11.3334 7.06061 11.3334H8.27273C9.2537 11.3334 10.1802 11.5665 11 11.9803C12.9773 12.9783 14.3333 15.0278 14.3333 17.394C14.3333 17.7288 14.062 18.0001 13.7273 18.0001H1.60606C1.27134 18.0001 1 17.7288 1 17.394ZM16.5317 18.0001H20.3939C20.7287 18.0001 21 17.7288 21 17.394C21 14.0469 18.2866 11.3334 14.9394 11.3334C14.267 11.3334 13.9773 12.1386 14.3887 12.6705C15.3989 13.9766 16 15.6151 16 17.394C16 17.7026 16.2232 18.0001 16.5317 18.0001Z'
      fill='#42ABE9'
    />
  </svg>
);

export const TimeIcon = ({ className, color, disabled, ...rest }) => (
  <svg
    className={className}
    width='22'
    height='22'
    viewBox='0 0 22 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...rest}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.7456 18.7413C15.1615 18.7413 18.7413 15.1615 18.7413 10.7456C18.7413 6.32976 15.1615 2.75 10.7456 2.75C6.32976 2.75 2.75 6.32976 2.75 10.7456C2.75 15.1615 6.32976 18.7413 10.7456 18.7413ZM11.7451 6.08151C11.7451 5.52953 11.2976 5.08206 10.7456 5.08206C10.1936 5.08206 9.74617 5.52953 9.74617 6.08151L9.74617 11.2454L12.8112 13.5441C13.2527 13.8753 13.8792 13.7858 14.2104 13.3442C14.5416 12.9026 14.4521 12.2762 14.0105 11.945L11.7451 10.2459L11.7451 6.08151Z'
      fill={disabled ? '#C5C7D4' : color}
    />
  </svg>
);

export const ArrowDownIcon = ({ className }) => (
  <svg
    className={className}
    width='24'
    height='25'
    viewBox='0 0 24 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.71005 12.21L11.3001 14.8C11.6901 15.19 12.3201 15.19 12.7101 14.8L15.3001 12.21C15.9301 11.58 15.4801 10.5 14.5901 10.5H9.41005C8.52005 10.5 8.08005 11.58 8.71005 12.21Z'
      fill='#42ABE9'
    />
  </svg>
);

export const ArrowUpIcon = ({ className }) => (
  <svg
    className={className}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.71005 12.29L11.3001 9.7C11.6901 9.31 12.3201 9.31 12.7101 9.7L15.3001 12.29C15.9301 12.92 15.4801 14 14.5901 14H9.41005C8.52005 14 8.08005 12.92 8.71005 12.29Z'
      fill='#42ABE9'
    />
  </svg>
);
export const SortAscIcon = ({ className }) => (
  <svg
    className={className}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M5.8125 15C5.36377 15 5 15.4477 5 16C5 16.5523 5.36377 17 5.8125 17H18.1875C18.6362 17 19 16.5523 19 16C19 15.4477 18.6362 15 18.1875 15L5.8125 15Z'
      fill='#42ABE9'
    />
    <path
      d='M5 12C5 11.4477 5.36377 11 5.8125 11H14.75C15.1987 11 15.5625 11.4477 15.5625 12C15.5625 12.5523 15.1987 13 14.75 13L5.8125 13C5.36377 13 5 12.5523 5 12Z'
      fill='#42ABE9'
    />
    <path
      d='M5.8125 7C5.36377 7 5 7.44771 5 8C5 8.55228 5.36377 9 5.8125 9H11.125C11.5737 9 11.9375 8.55228 11.9375 8C11.9375 7.44772 11.5737 7 11.125 7H5.8125Z'
      fill='#42ABE9'
    />
  </svg>
);

export const SortDescIcon = ({ className }) => (
  <svg
    className={className}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M5.8125 9C5.36377 9 5 8.55228 5 8C5 7.44772 5.36377 7 5.8125 7H18.1875C18.6362 7 19 7.44771 19 8C19 8.55228 18.6362 9 18.1875 9L5.8125 9Z'
      fill='#42ABE9'
    />
    <path
      d='M5 12C5 12.5523 5.36377 13 5.8125 13H14.75C15.1987 13 15.5625 12.5523 15.5625 12C15.5625 11.4477 15.1987 11 14.75 11L5.8125 11C5.36377 11 5 11.4477 5 12Z'
      fill='#42ABE9'
    />
    <path
      d='M5.8125 17C5.36377 17 5 16.5523 5 16C5 15.4477 5.36377 15 5.8125 15H11.125C11.5737 15 11.9375 15.4477 11.9375 16C11.9375 16.5523 11.5737 17 11.125 17H5.8125Z'
      fill='#42ABE9'
    />
  </svg>
);

export const SortIcon = ({ direction }) => (
  <StyledIconLink>
    {direction === SortDirections.Asc ? <SortAscIcon /> : <SortDescIcon />}
  </StyledIconLink>
);

const StyledIconLink = styled.span`
  & > svg {
    margin-bottom: -3px;
    margin-left: 3px;
  }
  &:hover {
    & path {
      fill: #1786c7;
    }
  }
`;

export const DropIcon = (props) => (
  <svg
    {...props}
    width='17'
    height='13'
    viewBox='0 0 17 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.239088 0.155206C0.521568 -0.0809468 0.942004 -0.0433916 1.17816 0.239088L5.49556 5.40345L8.52145 3.47306C8.7981 3.29657 9.16205 3.34765 9.37943 3.59349L15.8328 10.8917C16.0766 11.1676 16.0508 11.5889 15.7749 11.8328C15.4991 12.0766 15.0778 12.0508 14.8339 11.7749L8.75809 4.90365L5.71856 6.84274C5.43599 7.02301 5.06351 6.96545 4.84853 6.7083L0.155206 1.09428C-0.0809468 0.811795 -0.0433916 0.39136 0.239088 0.155206Z'
      fill='#F34456'
    />
    <path
      d='M15.75 8.16699V11.667H12.25'
      stroke='#F34456'
      strokeWidth='1.3'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const PrinterIcon = ({ width = 24, height = 24, ...rest }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...rest}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 7H6V3C6 2.44772 6.44772 2 7 2H17C17.5523 2 18 2.44772 18 3V7H20C21.1046 7 22 7.89543 22 9V17C22 18.1046 21.1046 19 20 19H18V21C18 21.5523 17.5523 22 17 22H7C6.44771 22 6 21.5523 6 21V19H4C2.89543 19 2 18.1046 2 17V9C2 7.89543 2.89543 7 4 7ZM16 7H8V4H16V7ZM19 17H18V16C18 15.4477 17.5523 15 17 15H7C6.44772 15 6 15.4477 6 16V17H5C4.44772 17 4 16.5523 4 16V10C4 9.44772 4.44772 9 5 9H19C19.5523 9 20 9.44772 20 10V16C20 16.5523 19.5523 17 19 17ZM16 17H8V20H16V17ZM19 11C19 10.4477 18.5523 10 18 10C17.4477 10 17 10.4477 17 11C17 11.5523 17.4477 12 18 12C18.5523 12 19 11.5523 19 11Z'
      fill='white'
    />
  </svg>
);

export const CalendarIcon = ({ width = 20, height = 20 }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1.66663 7.50002C1.66663 6.25387 1.66663 5.63079 1.93457 5.16669C2.11011 4.86265 2.36259 4.61017 2.66663 4.43464C3.13073 4.16669 3.7538 4.16669 4.99996 4.16669H15C16.2461 4.16669 16.8692 4.16669 17.3333 4.43464C17.6373 4.61017 17.8898 4.86265 18.0653 5.16669C18.3333 5.63079 18.3333 6.25387 18.3333 7.50002C18.3333 7.81156 18.3333 7.96733 18.2663 8.08335C18.2224 8.15936 18.1593 8.22248 18.0833 8.26637C17.9673 8.33335 17.8115 8.33335 17.5 8.33335H2.49996C2.18842 8.33335 2.03265 8.33335 1.91663 8.26637C1.84062 8.22248 1.7775 8.15936 1.73361 8.08335C1.66663 7.96733 1.66663 7.81156 1.66663 7.50002Z'
      fill='white'
    />
    <path
      d='M1.66663 14.3333C1.66663 16.2189 1.66663 17.1617 2.25241 17.7475C2.8382 18.3333 3.78101 18.3333 5.66663 18.3333H14.3333C16.2189 18.3333 17.1617 18.3333 17.7475 17.7475C18.3333 17.1617 18.3333 16.2189 18.3333 14.3333V11C18.3333 10.5286 18.3333 10.2929 18.1868 10.1464C18.0404 9.99998 17.8047 9.99998 17.3333 9.99998H2.66663C2.19522 9.99998 1.95952 9.99998 1.81307 10.1464C1.66663 10.2929 1.66663 10.5286 1.66663 11V14.3333Z'
      fill='white'
    />
    <path
      d='M5.83337 2.5L5.83337 5'
      stroke='white'
      strokeWidth='2'
      strokeLinecap='round'
    />
    <path
      d='M14.1666 2.5L14.1666 5'
      stroke='white'
      strokeWidth='2'
      strokeLinecap='round'
    />
  </svg>
);

export const RightArrowOpen = ({ color, ...rest }) => (
  <svg
    {...rest}
    width='9'
    height='16'
    viewBox='0 0 9 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.26307 8L0.459355 13.1364C-0.153118 13.7913 -0.153118 14.8539 0.459355 15.5088C1.07183 16.1637 2.0641 16.1637 2.67657 15.5088L8.54762 9.23114C8.86586 8.89246 9.00997 8.44462 8.99947 8C9.00997 7.55538 8.86586 7.10754 8.54762 6.76886L2.67657 0.491172C2.0641 -0.163723 1.07183 -0.163723 0.459355 0.491172C-0.153118 1.14607 -0.153118 2.20867 0.459355 2.86356L5.26307 8Z'
      fill={color ?? '#E3F2FC'}
    />
  </svg>
);

export const RightArrowNarrowOpen = ({ color, ...rest }) => (
  <svg
    {...rest}
    width='10'
    height='18'
    viewBox='0 0 10 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.87861 9.70703C7.26913 9.31651 7.26913 8.68334 6.8786 8.29282L0.999924 2.41414C0.6094 2.02361 0.609401 1.39045 0.999925 0.999924C1.39045 0.6094 2.02361 0.6094 2.41414 0.999924L9.70703 8.29282C10.0976 8.68334 10.0976 9.31651 9.70703 9.70703L2.41414 16.9999C2.02361 17.3904 1.39045 17.3904 0.999925 16.9999C0.609401 16.6094 0.609401 15.9762 0.999925 15.5857L6.87861 9.70703Z'
      fill={color ?? '#E3F2FC'}
    />
  </svg>
);

export const OfflineStatusIcon = (props) => (
  <svg
    {...props}
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill='#FFC500'
      d='M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM9.78 5H9.72C9.32 5 9 5.32 9 5.72V10.44C9 10.79 9.18 11.12 9.49 11.3L13.64 13.79C13.98 13.99 14.42 13.89 14.62 13.55C14.83 13.21 14.72 12.76 14.37 12.56L10.5 10.26V5.72C10.5 5.32 10.18 5 9.78 5Z'
    />
  </svg>
);

export const OnlineStatusIcon = (props) => (
  <svg
    {...props}
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill='#479A19'
      d='M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM9.78 5H9.72C9.32 5 9 5.32 9 5.72V10.44C9 10.79 9.18 11.12 9.49 11.3L13.64 13.79C13.98 13.99 14.42 13.89 14.62 13.55C14.83 13.21 14.72 12.76 14.37 12.56L10.5 10.26V5.72C10.5 5.32 10.18 5 9.78 5Z'
    />
  </svg>
);

export const LongOfflineStatusIcon = (props) => (
  <svg
    {...props}
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill='#FD441C'
      d='M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM9.78 5H9.72C9.32 5 9 5.32 9 5.72V10.44C9 10.79 9.18 11.12 9.49 11.3L13.64 13.79C13.98 13.99 14.42 13.89 14.62 13.55C14.83 13.21 14.72 12.76 14.37 12.56L10.5 10.26V5.72C10.5 5.32 10.18 5 9.78 5Z'
    />
  </svg>
);

export const LeftArrowIcon = ({ disabled, ...rest }) => (
  <svg
    {...rest}
    width='18'
    height='12'
    viewBox='0 0 18 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.292893 5.29274C-0.097631 5.68327 -0.0976311 6.31643 0.292893 6.70696L4.87868 11.2927C5.2692 11.6833 5.90237 11.6833 6.29289 11.2927C6.68342 10.9022 6.68342 10.2691 6.29289 9.87853L3.41421 6.99985L17 6.99985C17.5523 6.99985 18 6.55213 18 5.99985C18 5.44756 17.5523 4.99985 17 4.99985L3.41421 4.99985L6.29289 2.12117C6.68342 1.73065 6.68342 1.09748 6.29289 0.706956C5.90237 0.316431 5.2692 0.316431 4.87868 0.706956L0.292893 5.29274Z'
      fill={disabled ? '#D8D8D8' : '#42ABE9'}
    />
  </svg>
);

export const RightArrowIcon = ({ disabled, ...rest }) => (
  <svg
    {...rest}
    width='18'
    height='12'
    viewBox='0 0 18 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.7071 5.29274C18.0976 5.68327 18.0976 6.31643 17.7071 6.70696L13.1213 11.2927C12.7308 11.6833 12.0976 11.6833 11.7071 11.2927C11.3166 10.9022 11.3166 10.2691 11.7071 9.87853L14.5858 6.99985L1 6.99985C0.447716 6.99985 0 6.55213 0 5.99985C0 5.44756 0.447716 4.99985 1 4.99985L14.5858 4.99985L11.7071 2.12117C11.3166 1.73065 11.3166 1.09748 11.7071 0.706956C12.0976 0.316431 12.7308 0.316431 13.1213 0.706956L17.7071 5.29274Z'
      fill={disabled ? '#D8D8D8' : '#42ABE9'}
    />
  </svg>
);

export const RadioButtonIcon = ({ disabled, ...rest }) => (
  <svg
    {...rest}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      cx='12'
      cy='12'
      r='9'
      fill='white'
      stroke={disabled ? '#D7DDE4' : '#42ABE9'}
      strokeWidth='2'
    />
    {!disabled && <circle cx='12' cy='12' r='5' fill='#42ABE9' />}
  </svg>
);

export const PersonIcon = ({ color, disabled, ...rest }) => (
  <svg
    {...rest}
    width='22'
    height='22'
    viewBox='0 0 22 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.0003 6.33333C11.0003 8.17428 9.50796 9.66667 7.66701 9.66667C5.82606 9.66667 4.33368 8.17428 4.33368 6.33333C4.33368 4.49238 5.82606 3 7.66701 3C9.50796 3 11.0003 4.49238 11.0003 6.33333ZM17.6663 7.16684C17.6663 8.54755 16.547 9.66684 15.1663 9.66684C13.7856 9.66684 12.6663 8.54755 12.6663 7.16684C12.6663 5.78613 13.7856 4.66684 15.1663 4.66684C16.547 4.66684 17.6663 5.78613 17.6663 7.16684ZM1 17.394C1 14.0469 3.71343 11.3334 7.06061 11.3334H8.27273C9.2537 11.3334 10.1802 11.5665 11 11.9803C12.9773 12.9783 14.3333 15.0278 14.3333 17.394C14.3333 17.7288 14.062 18.0001 13.7273 18.0001H1.60606C1.27134 18.0001 1 17.7288 1 17.394ZM16.5317 18.0001H20.3939C20.7287 18.0001 21 17.7288 21 17.394C21 14.0469 18.2866 11.3334 14.9394 11.3334C14.267 11.3334 13.9773 12.1386 14.3887 12.6705C15.3989 13.9766 16 15.6151 16 17.394C16 17.7026 16.2232 18.0001 16.5317 18.0001Z'
      fill={disabled ? '#C5C7D4' : color}
    />
  </svg>
);

export const CheckBoxIcon = ({ checked, color, ...rest }) => (
  <svg
    {...rest}
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.5 7C2.5 4.23858 4.73858 2 7.5 2H17.5C20.2614 2 22.5 4.23858 22.5 7V17C22.5 19.7614 20.2614 22 17.5 22H7.5C4.73858 22 2.5 19.7614 2.5 17V7Z'
      fill={checked ? color : '#C5C7D4'}
    />
    {checked && (
      <path
        d='M7.5 12.2333L10.6818 15.5L17.5 8.5'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
      />
    )}
  </svg>
);

export const EmptyCheckBoxIcon = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1 5C1 2.79086 2.79086 1 5 1H15C17.2091 1 19 2.79086 19 5V15C19 17.2091 17.2091 19 15 19H5C2.79086 19 1 17.2091 1 15V5Z'
      fill='white'
      stroke='#C5C7D4'
      strokeWidth='2'
    />
  </svg>
);

export const TeachersIcon = (props) => (
  <svg
    {...props}
    width='21'
    height='18'
    viewBox='0 0 21 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3.00027 10.1803V12.9903C3.00027 13.7203 3.40027 14.4003 4.04027 14.7503L9.04027 17.4803C9.64027 17.8103 10.3603 17.8103 10.9603 17.4803L15.9603 14.7503C16.6003 14.4003 17.0003 13.7203 17.0003 12.9903V10.1803L10.9603 13.4803C10.3603 13.8103 9.64027 13.8103 9.04027 13.4803L3.00027 10.1803ZM9.04027 0.520273L0.610273 5.12027C-0.0797266 5.50027 -0.0797266 6.50027 0.610273 6.88027L9.04027 11.4803C9.64027 11.8103 10.3603 11.8103 10.9603 11.4803L19.0003 7.09027V13.0003C19.0003 13.5503 19.4503 14.0003 20.0003 14.0003C20.5503 14.0003 21.0003 13.5503 21.0003 13.0003V6.59027C21.0003 6.22027 20.8003 5.89027 20.4803 5.71027L10.9603 0.520273C10.3603 0.200273 9.64027 0.200273 9.04027 0.520273Z'
      fill='#42ABE9'
    />
  </svg>
);

export const StudentsIcon = (props) => (
  <svg
    {...props}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 10C5.33 10 0 11.34 0 14V15C0 15.55 0.45 16 1 16H15C15.55 16 16 15.55 16 15V14C16 11.34 10.67 10 8 10Z'
      fill='#42ABE9'
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM11.8284 10.4142L10.4142 9L11.8284 7.58579C12.219 7.19526 12.219 6.5621 11.8284 6.17157C11.4379 5.78105 10.8047 5.78105 10.4142 6.17157L9 7.58579L7.58579 6.17157C7.19526 5.78105 6.5621 5.78105 6.17157 6.17157C5.78105 6.5621 5.78105 7.19526 6.17157 7.58579L7.58579 9L6.17157 10.4142C5.78105 10.8047 5.78105 11.4379 6.17157 11.8284C6.5621 12.219 7.19526 12.219 7.58579 11.8284L9 10.4142L10.4142 11.8284C10.8047 12.219 11.4379 12.219 11.8284 11.8284C12.219 11.4379 12.219 10.8047 11.8284 10.4142Z'
      fill='#D8D8D8'
    />
  </svg>
);

export const MinusIcon = (props) => (
  <svg
    {...props}
    width='14'
    height='2'
    viewBox='0 0 14 2'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M0.56 1.794V0.702H13.44V1.794H0.56Z' fill='#242527' />
  </svg>
);

export const AlertIcon = (props) => (
  <svg
    {...props}
    width='22'
    height='22'
    viewBox='0 0 22 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11ZM20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11ZM11.0003 16.9983C11.5528 16.9983 12.0007 16.5506 12.0007 15.9983C12.0007 15.4461 11.5528 14.9983 11.0003 14.9983C10.4479 14.9983 10 15.4461 10 15.9983C10 16.5506 10.4479 16.9983 11.0003 16.9983ZM12.0036 5.99835C12.0036 5.44606 11.5556 4.99835 11.0033 4.99835C10.451 4.99835 10.003 5.44606 10.003 5.99835V11.9983C10.003 12.5506 10.451 12.9983 11.0033 12.9983C11.5556 12.9983 12.0036 12.5506 12.0036 11.9983V5.99835Z'
      fill='#F34456'
    />
  </svg>
);

export const MinusLargeIcon = (props) => (
  <svg
    {...props}
    width='34'
    height='5'
    viewBox='0 0 34 5'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M0.44 4.332V0.299999H33.56V4.332H0.44Z' fill='#2BA1E6' />
  </svg>
);

export const CheckIcon = (props) => (
  <svg
    {...props}
    width='12'
    height='10'
    viewBox='0 0 12 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.5069 0.244029C12.0599 0.640184 12.1633 1.37882 11.738 1.89382L5.42225 9.54084C5.18842 9.82396 4.82915 9.9928 4.44571 9.99978C4.06227 10.0067 3.69619 9.85109 3.45067 9.57669L0.292803 6.0473C-0.153801 5.54815 -0.0813925 4.80632 0.454532 4.39036C0.990456 3.97441 1.78695 4.04185 2.23356 4.54099L4.3816 6.94175L9.73559 0.45922C10.1609 -0.0557822 10.954 -0.152126 11.5069 0.244029Z'
      fill='#42ABE9'
    />
  </svg>
);

export const CleverIcon = (props) => (
  <svg
    {...props}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='16' height='16' rx='2' fill='#42ABE9' />
    <path
      d='M8.836 4.26C7.916 4.26 7.192 4.568 6.664 5.184C6.136 5.8 5.872 6.644 5.872 7.716C5.872 8.78 6.116 9.624 6.604 10.248C7.1 10.864 7.84 11.172 8.824 11.172C9.2 11.172 9.556 11.14 9.892 11.076C10.228 11.012 10.556 10.932 10.876 10.836V11.772C10.556 11.892 10.224 11.98 9.88 12.036C9.544 12.092 9.14 12.12 8.668 12.12C7.796 12.12 7.068 11.94 6.484 11.58C5.9 11.22 5.46 10.708 5.164 10.044C4.876 9.38 4.732 8.6 4.732 7.704C4.732 6.84 4.888 6.08 5.2 5.424C5.52 4.76 5.988 4.244 6.604 3.876C7.22 3.5 7.968 3.312 8.848 3.312C9.752 3.312 10.54 3.48 11.212 3.816L10.78 4.728C10.516 4.608 10.22 4.5 9.892 4.404C9.572 4.308 9.22 4.26 8.836 4.26Z'
      fill='white'
    />
  </svg>
);

export const ClassLinkIcon = (props) => (
  <svg
    {...props}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='16' height='16' rx='2' fill='#3F66CB' />
    <path
      d='M5.8985 4.26C4.9785 4.26 4.2545 4.568 3.7265 5.184C3.1985 5.8 2.9345 6.644 2.9345 7.716C2.9345 8.78 3.1785 9.624 3.6665 10.248C4.1625 10.864 4.9025 11.172 5.8865 11.172C6.2625 11.172 6.6185 11.14 6.9545 11.076C7.2905 11.012 7.6185 10.932 7.9385 10.836V11.772C7.6185 11.892 7.2865 11.98 6.9425 12.036C6.6065 12.092 6.2025 12.12 5.7305 12.12C4.8585 12.12 4.1305 11.94 3.5465 11.58C2.9625 11.22 2.5225 10.708 2.2265 10.044C1.9385 9.38 1.7945 8.6 1.7945 7.704C1.7945 6.84 1.9505 6.08 2.2625 5.424C2.5825 4.76 3.0505 4.244 3.6665 3.876C4.2825 3.5 5.0305 3.312 5.9105 3.312C6.8145 3.312 7.6025 3.48 8.2745 3.816L7.8425 4.728C7.5785 4.608 7.2825 4.5 6.9545 4.404C6.6345 4.308 6.2825 4.26 5.8985 4.26ZM9.80853 12V3.432H10.8885V11.04H14.6325V12H9.80853Z'
      fill='white'
    />
  </svg>
);

export const OnlineStatusIconSmall = (props) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.99331 0.333344C3.31331 0.333344 0.333313 3.32001 0.333313 7.00001C0.333313 10.68 3.31331 13.6667 6.99331 13.6667C10.68 13.6667 13.6666 10.68 13.6666 7.00001C13.6666 3.32001 10.68 0.333344 6.99331 0.333344ZM6.99998 12.3333C4.05331 12.3333 1.66665 9.94668 1.66665 7.00001C1.66665 4.05334 4.05331 1.66668 6.99998 1.66668C9.94665 1.66668 12.3333 4.05334 12.3333 7.00001C12.3333 9.94668 9.94665 12.3333 6.99998 12.3333ZM6.85331 3.66668H6.81331C6.54665 3.66668 6.33331 3.88001 6.33331 4.14668V7.29334C6.33331 7.52668 6.45331 7.74668 6.65998 7.86668L9.42665 9.52668C9.65331 9.66001 9.94665 9.59334 10.08 9.36668C10.22 9.14001 10.1466 8.84001 9.91331 8.70668L7.33331 7.17334V4.14668C7.33331 3.88001 7.11998 3.66668 6.85331 3.66668V3.66668Z'
      fill='#479A19'
    />
  </svg>
);

export const LongOfflineStatusIconSmall = (props) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.99331 0.333344C3.31331 0.333344 0.333313 3.32001 0.333313 7.00001C0.333313 10.68 3.31331 13.6667 6.99331 13.6667C10.68 13.6667 13.6666 10.68 13.6666 7.00001C13.6666 3.32001 10.68 0.333344 6.99331 0.333344ZM6.99998 12.3333C4.05331 12.3333 1.66665 9.94668 1.66665 7.00001C1.66665 4.05334 4.05331 1.66668 6.99998 1.66668C9.94665 1.66668 12.3333 4.05334 12.3333 7.00001C12.3333 9.94668 9.94665 12.3333 6.99998 12.3333ZM6.85331 3.66668H6.81331C6.54665 3.66668 6.33331 3.88001 6.33331 4.14668V7.29334C6.33331 7.52668 6.45331 7.74668 6.65998 7.86668L9.42665 9.52668C9.65331 9.66001 9.94665 9.59334 10.08 9.36668C10.22 9.14001 10.1466 8.84001 9.91331 8.70668L7.33331 7.17334V4.14668C7.33331 3.88001 7.11998 3.66668 6.85331 3.66668V3.66668Z'
      fill='#FFC500'
    />
  </svg>
);

export const OfflineStatusIconSmall = (props) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.99331 0.333344C3.31331 0.333344 0.333313 3.32001 0.333313 7.00001C0.333313 10.68 3.31331 13.6667 6.99331 13.6667C10.68 13.6667 13.6666 10.68 13.6666 7.00001C13.6666 3.32001 10.68 0.333344 6.99331 0.333344ZM6.99998 12.3333C4.05331 12.3333 1.66665 9.94668 1.66665 7.00001C1.66665 4.05334 4.05331 1.66668 6.99998 1.66668C9.94665 1.66668 12.3333 4.05334 12.3333 7.00001C12.3333 9.94668 9.94665 12.3333 6.99998 12.3333ZM6.85331 3.66668H6.81331C6.54665 3.66668 6.33331 3.88001 6.33331 4.14668V7.29334C6.33331 7.52668 6.45331 7.74668 6.65998 7.86668L9.42665 9.52668C9.65331 9.66001 9.94665 9.59334 10.08 9.36668C10.22 9.14001 10.1466 8.84001 9.91331 8.70668L7.33331 7.17334V4.14668C7.33331 3.88001 7.11998 3.66668 6.85331 3.66668V3.66668Z'
      fill='#FD441C'
    />
  </svg>
);

export const DownloadIcon = (props) => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.06 4.66669H8V1.33335C8 0.966687 7.7 0.666687 7.33333 0.666687H4.66667C4.3 0.666687 4 0.966687 4 1.33335V4.66669H2.94C2.34667 4.66669 2.04667 5.38669 2.46667 5.80669L5.52667 8.86669C5.78667 9.12669 6.20667 9.12669 6.46667 8.86669L9.52667 5.80669C9.94667 5.38669 9.65333 4.66669 9.06 4.66669ZM0 11.3334C0 11.7 0.3 12 0.666667 12H11.3333C11.7 12 12 11.7 12 11.3334C12 10.9667 11.7 10.6667 11.3333 10.6667H0.666667C0.3 10.6667 0 10.9667 0 11.3334Z'
      fill='white'
    />
  </svg>
);

export const InfoIcon = (props) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.99996 1.66666C5.39996 1.66666 1.66663 5.39999 1.66663 9.99999C1.66663 14.6 5.39996 18.3333 9.99996 18.3333C14.6 18.3333 18.3333 14.6 18.3333 9.99999C18.3333 5.39999 14.6 1.66666 9.99996 1.66666ZM9.99996 14.1667C9.54163 14.1667 9.16663 13.7917 9.16663 13.3333V9.99999C9.16663 9.54166 9.54163 9.16666 9.99996 9.16666C10.4583 9.16666 10.8333 9.54166 10.8333 9.99999V13.3333C10.8333 13.7917 10.4583 14.1667 9.99996 14.1667ZM10.8333 6.66666C10.8333 7.12689 10.4602 7.49999 9.99996 7.49999V7.49999C9.53972 7.49999 9.16663 7.12689 9.16663 6.66666V6.66666C9.16663 6.20642 9.53972 5.83332 9.99996 5.83332V5.83332C10.4602 5.83332 10.8333 6.20642 10.8333 6.66666V6.66666Z'
      fill='#42ABE9'
    />
  </svg>
);

export const BigHelpIcon = ({ ...rest }) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...rest}
  >
    <g opacity='0.7'>
      <path
        d='M9.99996 1.66666C5.39996 1.66666 1.66663 5.39999 1.66663 9.99999C1.66663 14.6 5.39996 18.3333 9.99996 18.3333C14.6 18.3333 18.3333 14.6 18.3333 9.99999C18.3333 5.39999 14.6 1.66666 9.99996 1.66666ZM10.8333 15C10.8333 15.4602 10.4602 15.8333 9.99996 15.8333C9.53972 15.8333 9.16663 15.4602 9.16663 15C9.16663 14.5398 9.53972 14.1667 9.99996 14.1667C10.4602 14.1667 10.8333 14.5398 10.8333 15ZM12.5583 9.37499L11.8083 10.1417C11.3916 10.5667 11.0916 10.95 10.9416 11.55C10.9069 11.6889 10.879 11.8369 10.8601 12.0009C10.8287 12.2753 10.6094 12.5 10.3333 12.5H9.58329C9.35317 12.5 9.16663 12.3134 9.16663 12.0833C9.16663 11.7 9.23329 11.3333 9.34996 10.9917C9.51663 10.5083 9.79163 10.075 10.1416 9.72499L11.175 8.67499C11.5583 8.30832 11.7416 7.75832 11.6333 7.17499C11.525 6.57499 11.0583 6.06666 10.475 5.89999C9.54996 5.64166 8.69163 6.16666 8.41663 6.95832C8.31663 7.26666 8.05829 7.49999 7.73329 7.49999H7.48329C6.99996 7.49999 6.66663 7.03332 6.79996 6.56666C7.15829 5.34166 8.19996 4.40832 9.49163 4.20832C10.7583 4.00832 11.9666 4.66666 12.7166 5.70832C13.7 7.06666 13.4083 8.52499 12.5583 9.37499Z'
        fill='#9096AA'
      />
    </g>
  </svg>
);
